module.exports = __webpack_public_path__ + "img/bg3.9afb625f.png";